import { DocumentationCardContentViewType } from './types';
import { DependenciesContent } from './DependenciesContent';
import CommentsList from './annotations/comments/CommentsList';
import { useSelector } from 'react-redux';
import { selectCardContentType } from '../../../reducers/documentation/documentationCardReducer';
import { SourceView } from './source-view/SourceView';
import { TagEditPage } from './annotations/tags/TagEditPage';
import { SalesforceItem } from '../../parser/ParserTypes';

interface DocumentationCardContentRendererProps {
  crmOrgId: string;
  configurationItem: SalesforceItem;
  type: string;
  isReadOnly?: boolean;
}

export const DocumentationCardContentRenderer = ({
  crmOrgId,
  configurationItem,
  type,
  isReadOnly = false,
}: DocumentationCardContentRendererProps) => {
  const contentType = useSelector(selectCardContentType);

  if (!contentType) {
    return <></>;
  }

  return (
    <>
      {contentType === DocumentationCardContentViewType.default && (
        <DependenciesContent
          key={configurationItem.id}
          crmOrgId={crmOrgId}
          configurationItem={configurationItem}
          type={type}
          isReadOnly={isReadOnly}
        />
      )}

      {contentType === DocumentationCardContentViewType.comments && (
        <CommentsList configurationItem={configurationItem} crmOrgId={crmOrgId} parentType={type} />
      )}

      {contentType === DocumentationCardContentViewType.sourceCode && (
        <SourceView
          configurationItem={configurationItem}
          crmOrgId={crmOrgId}
          parentType={type}
          readOnly={isReadOnly}
        />
      )}

      {contentType === DocumentationCardContentViewType.editTag && (
        <TagEditPage tagId={configurationItem.id} crmOrgId={crmOrgId} />
      )}
    </>
  );
};
